import React, { useState } from 'react';
import Navbar from '../Header/Navbar';
import Footer from '../Footer/Footer';
import BackToTop from '../BackToTop/BackToTop';
import Topbar from '../Header/Topbar';
import ProductGrid from './ProductGrid';
import Pagination from './Pagination';
import SEO from '../SEO/SEO';
import './Products.css';

const LithiumProducts = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');

  const lithiumCategories = [
    { id: 'torque-lithium', name: 'TORQUE 12.8V Lithium Batteries', products: [], brand: 'lithium' },
    { id: 'wall-mounted', name: 'Smart Wall-Mounted Inverter', products: [], brand: 'lithium' },
    { id: 'solar-solutions', name: 'Lithium Solar Solutions', products: [], brand: 'lithium' }
  ];

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const clearSearch = () => {
    setSearchQuery('');
    setCurrentPage(1);
  };

  const getTotalProducts = () => {
    const productCounts = {
      'torque-lithium': 3,
      'wall-mounted': 2,
      'solar-solutions': 1
    };
    
    return Object.values(productCounts).reduce((sum, count) => sum + count, 0);
  };

  // Color Options - Change these to customize
  const featureColor = '#0066CC'; // Change to: '#DE400E', '#DC143C', '#00A86B', etc.
  const featureBgColor = '#E3F2FD'; // Change to: '#FFF3E0', '#FFE4E1', '#E8F5E9', etc.

  const features = [
    {
      icon: 'fa-sparkles',
      title: 'Zero Maintenance',
      desc: 'No water refills required'
    },
    {
      icon: 'fa-leaf',
      title: 'Eco-Friendly',
      desc: 'Sustainable energy solution'
    },
    {
      icon: 'fa-shield-alt',
      title: '5-Year Warranty',
      desc: 'Complete peace of mind'
    },
    {
      icon: 'fa-bolt',
      title: 'Fast Charging',
      desc: 'Quick power restoration'
    },
    {
      icon: 'fa-microchip',
      title: 'Smart BMS',
      desc: 'Intelligent management system'
    }
  ];

  return (
    <>
      <SEO 
        title="Lithium Batteries"
        description="Switch to next-gen power with Torque Lithium batteries at Galaxy Power System, Chidambaram. High efficiency, fast charging, and zero maintenance."
        keywords="lithium battery dealer, torque lithium battery, solar lithium solution, lithium inverter chidambaram"
        canonicalUrl="https://galaxypowersystems.com/lithium-products"
        breadcrumbs={[
          { name: 'Home', url: '/' },
          { name: 'Lithium Products', url: '/lithium-products' }
        ]}
      />
      <Topbar />
      <Navbar />
      <div className="container-fluid product py-5" id="products">
        <div className="container py-5">
          <div className="row mb-5">
            <div className="col-12 text-center">
              <h1 className="display-5 mb-3" style={{ color: '#DC143C' }}>
                <i className="fas fa-battery-full me-2"></i> TORQUE Lithium Batteries
              </h1>
              <p className="lead text-muted mb-4">
                Experience next-generation power backup with TORQUE Lithium batteries. 
                Advanced lithium technology with extended warranty, zero maintenance, and smart features.
              </p>
            </div>
          </div>

          <div className="row g-4 align-items-center mb-5">
            <div className="col-lg-4 col-md-12">
              <h3 className="mb-0">All Lithium Products</h3>
            </div>
            
            <div className="col-lg-5 col-md-8">
              <div className="position-relative">
                <div className="d-flex border rounded-pill" style={{ backgroundColor: '#fff', borderColor: '#ddd' }}>
                  <input 
                    className="form-control border-0 rounded-pill w-100 py-2" 
                    type="text"
                    placeholder="Search lithium products..."
                    value={searchQuery}
                    onChange={handleSearch}
                    style={{ fontSize: '14px' }}
                  />
                  {searchQuery && (
                    <button 
                      type="button" 
                      className="btn btn-link text-danger"
                      onClick={clearSearch}
                      style={{ border: '0', fontSize: '14px' }}
                    >
                      <i className="fas fa-times"></i>
                    </button>
                  )}
                </div>
              </div>
            </div>
            
            <div className="col-lg-3 col-md-4 text-end">
              <div className="badge bg-danger rounded-pill py-2 px-4">
                Total Products: {getTotalProducts()}
              </div>
            </div>
          </div>

          {/* Key Features Section - HORIZONTAL LAYOUT */}
          <div className="row mb-5">
            <div className="col-12">
              <div 
                className="features-container"
                style={{
                  backgroundColor: featureBgColor,
                  border: `2px solid ${featureColor}`,
                  borderRadius: '8px',
                  padding: '30px 20px',
                  display: 'flex',
                  flexWrap: 'wrap',
                  justifyContent: 'space-around',
                  alignItems: 'center',
                  gap: '20px'
                }}
              >
                {features.map((feature, index) => (
                  <div
                    key={index}
                    style={{
                      flex: '0 1 18%',
                      minWidth: '120px',
                      textAlign: 'center',
                      padding: '15px',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center'
                    }}
                  >
                    <i 
                      className={`fas ${feature.icon} fa-2x`}
                      style={{ 
                        color: featureColor,
                        marginBottom: '12px'
                      }}
                    ></i>
                    <p 
                      style={{
                        margin: '8px 0',
                        fontWeight: 'bold',
                        fontSize: '14px',
                        color: '#333'
                      }}
                    >
                      {feature.title}
                    </p>
                    <small 
                      style={{
                        color: '#666',
                        fontSize: '12px',
                        lineHeight: '1.4'
                      }}
                    >
                      {feature.desc}
                    </small>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Responsive Styles */}
          <style>{`
            @media (max-width: 1024px) {
              .features-container {
                flex-wrap: wrap !important;
                padding: 20px !important;
              }
              
              .features-container > div {
                flex: 0 1 calc(50% - 10px) !important;
                min-width: 140px !important;
              }
            }
            
            @media (max-width: 768px) {
              .features-container {
                flex-direction: column !important;
                padding: 15px !important;
              }
              
              .features-container > div {
                flex: 0 1 100% !important;
                width: 100% !important;
              }
            }
            
            @media (max-width: 480px) {
              .features-container {
                gap: 15px !important;
                padding: 10px !important;
              }
              
              .features-container > div {
                flex: 0 1 100% !important;
              }
            }
          `}</style>
          
          <div className="tab-content">
            <ProductGrid 
              categories={lithiumCategories} 
              currentPage={currentPage} 
              brand="lithium"
              searchQuery={searchQuery}
            />
            
            {/* Pagination */}
            {!searchQuery && (
              <Pagination 
                totalPages={lithiumCategories.length}
                currentPage={currentPage}
                onPageChange={setCurrentPage}
                paginationId="lithium-pagination"
              />
            )}
          </div>

          {/* Contact Section */}
          <div className="row mt-5">
            <div className="col-12">
              <div className="card bg-light border-0">
                <div className="card-body text-center py-5">
                  <h4 className="card-title mb-3">Ready to Switch to Lithium?</h4>
                  <p className="card-text text-muted mb-4">
                    Contact us today for expert consultation and installation services
                  </p>
                  <a href="tel:+919865757472" className="btn btn-danger rounded-pill px-5">
                    <i className="fas fa-phone me-2"></i> Call: +91 98657 57472
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <BackToTop />
      <Footer />
    </>
  );
};

export default LithiumProducts;     